import React, {useState, useEffect, useLayoutEffect} from "react";
import CookieConsent from 'react-cookie-consent';
import styled from "styled-components";

const BannerContainer = styled.div`

  .CookieConsent {
    height: 321px;
    animation-duration: 1s;
    animation-name: startBanner;

    @keyframes startBanner{
       from {
       height: 0px;
      }

      to {
        height: 321px;
      }
    }
  }
`;

const TextBannerContainer = styled.div`
    
    margin-top: 20px;
    color: #222;
`;

const Title = styled.h4`

    color: #222;
    text-align: center;
    font-weight: bold;
    margin-top: 30px;
`;

const TextBanner = styled.p`

    padding-left: 20px;
    padding-right: 20px;
    margin-top: 10px;

    a {
        color: #91c508;
    }

    a:visited {
        color: #91c508;
    }
`;


const BannerCookies = () => {

    const [isMobile, setIsMobile] = useState(false);
    const [lastScrollPosition, setLastScrollPosition] = useState(0);
    const [isBannerAppear, setIsBannerAppear] = useState(false);
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);


    const onScroll = () => {
        
        const currentScrollPosition = window.pageYOffset ||
                document.documentElement.scrollTop;

        if(currentScrollPosition < 0){
            return;
        }

        if(currentScrollPosition >= 160){
            setIsBannerAppear(true);
        }else{
            setIsBannerAppear(false);
        }
    }

  useEffect(() => {

    //setTimeout(() => { setIsBannerAppear(true) },3000);

    if(typeof window !== "undefined"){

      setWidth(window.innerWidth);
      setHeight(window.innerHeight);

      window.addEventListener("scroll",onScroll);
      console.log("width inicial ",window.screen.width);
      console.log("height inicial ",window.screen.height);
      if(window.screen.width < 768){
          setIsMobile(true);
        }else{
          setIsMobile(false);
        }
    }
  },[]);

  useLayoutEffect(() => {

    if(typeof window !== "undefined"){

      const updateSize = () => {

        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
        console.log("resize ",window.screen.width);
        if(window.screen.width < 768){
          setIsMobile(true);
        }else{
          setIsMobile(false);
        }
      };
      

      window.addEventListener("resize",updateSize);
    }
  }, []);

    const setStyleButton = () => {
        if(isMobile){

            return {
                color: "#fff",
                backgroundColor: "#222",
                width: "220px",
                marginBottom: "50px",
                padding: "15px",
                fontSize: "14px",
                borderRadius: "15px",
                fontWeight: "bold"
            }
        }else{
            return {
                color: "#fff",
                backgroundColor: "#222",
                width: "100%",
                marginBottom: "50px"
            }
        }
    };
   
    return (
        <>
            {
              isBannerAppear ? 

              <BannerContainer>
                <CookieConsent
                  location="bottom"
                  buttonText="OK"
                  declineButtonText="Decline"
                  style={
                    {
                      background: "#fff",
                      color: "#222",
                      boxShadow: "-8px -7px 20px 0 rgb(0 0 0 / 10%)",
                      fontSize: "14px",
                      lineHeight: "1.3",
                      justifyContent: "center"
                    } 
                  }
                  contentStyle={
                    {
                    flex: "0 0 100%", 
                    textAlign: "center"
                    }
                  }
                  buttonStyle={
                    {
                    color: "#fff",
                    backgroundColor: "#222",
                    width: "220px",
                    marginBottom: height > width ? "50px" : "80px",
                    marginTop: "-10px",
                    padding: "15px",
                    fontSize: "14px",
                    borderRadius: "15px",
                    fontWeight: "bold"
                  }
                  }
                  cookieName="gatsby-gdpr-facebook-pixel">
                      <TextBannerContainer>
                        
                        <TextBanner>
                           <Title>Sobre las Cookies en Este Sitio Web</Title>
                            Utilizamos cookies y tecnologías similares para personalizar el contenido, adaptar y medir los anuncios y ofrecer una mejor experiencia de usuario. Al hacer clic en OK o seguir navegando, Usted acepta esta condición según lo establecido en nuestra
                                <a style={{marginLeft: "8px"}} href="https://dentalvipcaracas.com/uso-de-cookies/">
                                  Política de Cookies </a> 
                        </TextBanner>
                    </TextBannerContainer>
              </CookieConsent>
            </BannerContainer>
            : null}
        </>
    );
}

export default BannerCookies;